import type { CSSProperties } from "react";
import { cn } from "@wa/ui";
import { labelColor, labelsOf, type CrmLabel } from "../../lib/crmLabels";

/**
 * The labels a row carries, drawn the same way everywhere they appear.
 *
 * One component rather than a copy per surface: a label has to look identical in
 * the mail list, the call list and both reading panes, or an operator scanning
 * for red has to learn two shapes. Colour is a dot plus a tint, never colour
 * alone - the same rule `StatusPill` follows.
 *
 * Ids with no label behind them render nothing (`labelsOf` resolves against the
 * registry), so a deleted label leaves no ghost chip on the rows that had it.
 */
export function LabelChips({
  labels,
  tags,
  className,
}: {
  labels: readonly CrmLabel[];
  tags: readonly string[] | undefined;
  className?: string;
}) {
  const shown = labelsOf(labels, tags);
  if (!shown.length) return null;

  return (
    <span className={cn("flex flex-wrap gap-1.5", className)}>
      {shown.map((label) => (
        <span key={label.id} className="crm-lbl" style={{ "--crm-lbl-c": labelColor(label.tone) } as CSSProperties}>
          <i />
          {label.name}
        </span>
      ))}
    </span>
  );
}
